<template>
  <div
    class="sidebar-tooltip-trigger"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
    ref="triggerRef"
  >
    <slot></slot>

    <Teleport to="body">
      <div
        v-if="visible"
        class="custom-tooltip-box"
        :style="tooltipStyle"
      >
        <div class="tooltip-arrow"></div>
        {{ text }}
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const visible = ref(false);
const tooltipStyle = ref({ top: '0px', left: '0px' });
const triggerRef = ref(null);

const showTooltip = () => {
  if (props.disabled) return;
  if (!triggerRef.value) return;
  
  const rect = triggerRef.value.getBoundingClientRect();
  
  tooltipStyle.value = {
    top: `${rect.top + (rect.height / 2)}px`,
    left: `${rect.right + 12}px`
  };
  
  visible.value = true;
};

const hideTooltip = () => {
  visible.value = false;
};
</script>

<style scoped>
.sidebar-tooltip-trigger {
  display: flex;
  width: 100%;
}

.custom-tooltip-box {
  position: fixed;
  transform: translateY(-50%);
  background-color: #212529;
  color: #FFFFFF;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-family: "Docs Light", sans-serif;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 999999;
  pointer-events: none;
  animation: fadeIn 0.15s ease-out forwards;
}

.tooltip-arrow {
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent #212529 transparent transparent;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-5px, -50%);
  }
  to {
    opacity: 1;
    transform: translate(0, -50%);
  }
}
</style>